import service from '@/api/targetValue';
import {handleError} from '@/state/generators/helpers';
import {alert} from "../generators/helpers";

export const state = {
    targetValues: [],
    targetValueTypes: [],
    projectTypes: [],
    leadSources: [],
    sources: [],
    currencies: [],
    categories: [],
    billableCategories: [],
    service: service(),
    loading: false
}

export const getters = {
    targetValues: function (state) {
        return JSON.parse(JSON.stringify(state.targetValues))
    },
    targetValueTypes: function (state) {
        return JSON.parse(JSON.stringify(state.targetValueTypes))
    },
    projectTypes: function (state) {
        return JSON.parse(JSON.stringify(state.projectTypes))
    },
    leadSources: function (state) {
        return JSON.parse(JSON.stringify(state.leadSources))
    },
    sources: function (state) {
        return JSON.parse(JSON.stringify(state.sources))
    },
    currencies: function (state) {
        return JSON.parse(JSON.stringify(state.currencies))
    },
    categories: function (state) {
        return JSON.parse(JSON.stringify(state.categories))
    },
    billableCategories: function (state) {
        return JSON.parse(JSON.stringify(state.billableCategories))
    },
    loading: function (state) {
        return state.loading;
    }
}

export const mutations = {
    'SET_TARGET_VALUES': function (state, data = []) {
        state.targetValues = data;
    },
    'SET_TARGET_VALUE_TYPES': function (state, data = []) {
        state.targetValueTypes = data;
    },
    'SET_PROJECT_TYPES': function (state, data = []) {
        state.projectTypes = data;
    },
    'SET_LEAD_SOURCES': function (state, data = []) {
        state.leadSources = data;
    },
    'SET_SOURCES': function (state, data = []) {
        state.sources = data;
    },
    'SET_CURRENCIES': function (state, data = []) {
        state.currencies = data;
    },
    'SET_CATEGORIES': function (state, data = []) {
        state.categories = data;
    },
    'SET_BILLABLE_CATEGORIES': function (state, data = []) {
        state.billableCategories = data;
    },
    'SET_LOADING': function (state, loading = false) {
        state.loading = loading;
    },
}

export const actions = {
    user: function ({commit, state}, id) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.fetchUserTargetValues(id).then(response => {
            commit('SET_TARGET_VALUES', response.data.target_values);
            commit('SET_TARGET_VALUE_TYPES', response.data.target_value_types);
            commit('SET_PROJECT_TYPES', response.data.project_types);
            commit('SET_LEAD_SOURCES', response.data.lead_sources);
            commit('SET_SOURCES', response.data.sources);
            commit('SET_CURRENCIES', response.data.currencies);
            commit('SET_CATEGORIES', response.data.categories);
            commit('SET_BILLABLE_CATEGORIES', response.data.billable_categories);
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    save: function ({commit, state, getters}, id) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        const diff = [];

        Object.entries(getters.targetValues).forEach(([mixedKey, value]) => {
            Object.entries(value).forEach(([key, value]) => {
                if (
                    state.targetValues[mixedKey][key].daily !== value.daily
                    || state.targetValues[mixedKey][key].weekly !== value.weekly
                    || state.targetValues[mixedKey][key].monthly !== value.monthly
                    || state.targetValues[mixedKey][key].yearly !== value.yearly
                ) {
                    diff.push({
                        id: value.id,
                        daily: value.daily,
                        weekly: value.weekly,
                        monthly: value.monthly,
                        yearly: value.yearly,
                    });
                }
            })
        });

        return state.service.saveUserTargetValues(id, diff).then(response => {
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            alert(commit, this.$t('request.save_is_successful'));
            return response.data;
        }).catch((e) => {
            handleError(e, commit)
        });
    }
}
